module.exports = __webpack_public_path__ + "media/images/users/about_online_purchase.ja-3d0b444d668581dc0999b4387ed7db6f.png";